import React from 'react'
import PropTypes from 'prop-types'

const ArrowLeft = ({ color = '#5A5C57', width = '24px', height = '24px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icons-/-Dark-Grey-/-Arrow-Left"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline
        id="Path-7"
        stroke={color}
        strokeWidth="2"
        transform="translate(9.500000, 12.000000) scale(-1, 1) translate(-9.500000, -12.000000) "
        points="6 19 13 11.9987793 6 5"
      ></polyline>
    </g>
  </svg>
)

ArrowLeft.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default ArrowLeft
